import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { TabsContent } from '@/components/ui/tabs';

import { TabProps } from '../tabConfig';
import { LocationTable } from './table';

export function LocationsTab({ importTypeId, importTypeName }: TabProps) {
	return (
		<TabsContent value="locations">
			<Card>
				<CardHeader>
					<CardTitle>Locations</CardTitle>
					<CardDescription>Location Mappings for {importTypeName} - {importTypeId}</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<LocationTable importTypeId={importTypeId} />
				</CardContent>
			</Card>
		</TabsContent>
	);
}
